import { render, staticRenderFns } from "./FormContentComposerOptionsCanvas.vue?vue&type=template&id=0624b272"
import script from "./FormContentComposerOptionsCanvas.vue?vue&type=script&lang=js"
export * from "./FormContentComposerOptionsCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports